import styles from "../../components/Dialogs/DialogMessageInput/DialogMessageInput.module.scss"

export const scrollDownMessageInput = () => {
    const editorNode = document.querySelector(`.${styles.editor}`)

    if (editorNode) {
        editorNode.scrollTop = editorNode.scrollHeight
    }
}
